import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

function PasswordInput({
  password,
  onChangePassword,
  onResetPassword
}) {
  const { t } = useTranslation();

  const [pwCheckView, setPwCheckView] = useState(false);
  const [pwCheck, setPwCheck] = useState('');

  const onBlur = useCallback(() => {
    if (!password) return;
    let result = '';

    if (!password || password.length < 6) result = 'fail';
    else result = 'success';

    setPwCheck(result);
  }, [password]);

  const handleIsView = useCallback(() => {
    setPwCheckView(!pwCheckView);
  }, [pwCheckView]);
  
  
  return (
    <>
      <div className="input_box white_box">
        <input
          type={pwCheckView ? 'text' : 'password'}
          placeholder={t("MY_02_05.msg019", { c: 6 })}
          value={password}
          onBlur={onBlur}
          onChange={onChangePassword}
        />
        <div className="r_area">
          {
            password && (
              <button
                type="button"
                onClick={() => handleIsView(!pwCheckView)}
              >
                {
                  pwCheckView
                    ? <img src="./static/images/icon/btn_join_eye_on.svg" alt="" />
                    : <img src="./static/images/icon/btn_join_eye_off.svg" alt="" />
                }
              </button>
            )
          }
          {
            pwCheck && (
              pwCheck === 'success'
                ? <img src="./static/images/icon/ic_check.svg" alt="" />
                : <button type="button" onClick={onResetPassword}><img src="./static/images/icon/ic_error.svg" alt="" /></button>
            )
          }          
        </div>
      </div>
      {
        pwCheck && pwCheck === 'fail' && <div className="red_txt fs12_10">{t("MY_02_05.msg020", { c: 6 })}</div>
      } 
    </>
  );
}

export default PasswordInput;